import React from 'react';

const DupliquerSvg = ({width = 20, height = 20}) => (
    <svg width={width} height={height} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.666 4.25065V1.33398H1.66602V13.0007H4.52316" stroke="#002335" strokeWidth="2"/>
        <rect x="8.33398" y="8" width="10" height="11.6667" stroke="#002335" strokeWidth="2"/>
    </svg>
);

export default DupliquerSvg;
